import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { UserMenuComponent } from 'app/layout/common/user-menu/user-menu.component';
import { SharedModule } from 'app/shared/shared.module';
import { RouterModule } from '@angular/router';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AllDevicesLogoutDialogComponent } from './all-devices-logout-dialog/all-devices-logout-dialog.component';
import { FuseAlertModule } from '../../../../@fuse/components/alert';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { NgxCaptchaModule } from 'ngx-captcha';

@NgModule({
  declarations: [UserMenuComponent, AllDevicesLogoutDialogComponent],
  imports: [
    MatButtonModule,
    MatDividerModule,
    MatIconModule,
    MatMenuModule,
    MatProgressSpinnerModule,
    SharedModule,
    RouterModule,
    MatDialogModule,
    MatTooltipModule,
    FuseAlertModule,
    MatCheckboxModule,
    MatFormFieldModule,
    MatInputModule,
    NgxCaptchaModule,
  ],
  exports: [UserMenuComponent],
})
export class UserMenuModule {}
